import { render } from "./UploadTokoList.vue?vue&type=template&id=f01a0d2e&scoped=true"
import script from "./UploadTokoList.vue?vue&type=script&lang=js"
export * from "./UploadTokoList.vue?vue&type=script&lang=js"

import "./UploadTokoList.vue?vue&type=style&index=0&id=f01a0d2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f01a0d2e"

export default script